



























import {Vue, Component, PropSync, Prop} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import {ClaimType} from 'supporter';

@Component({
  components: {
    CompSelectBox,
    PeriodDateCalendar
  }
})
export default class SearchDateType extends Vue{
  @Prop({required: true})
  private readonly searchFormType!: ClaimType

  @PropSync('searchDateType')
  private searchDateTypeSync!: undefined | number;

  @PropSync('startYmd')
  private startYmdSync!: string;

  @PropSync('endYmd')
  private endYmdSync!: string;

  private PeriodOption = {
    name: 'startPeriod',
    periodTypes: ['td', 'ytd', '3d', '1w', '1m', '3m'],
    period: '1w'
  };
  private searchDateTypes = [
    {
      value: 'APPLY_YMDT',
      name: this.$t(`CLAIM_CONTENT_TOP_${this.searchFormType}_APPLY_YMDT`)
    },
    {
      value: 'COMPLETE_YMDT',
      name: this.$t(`CLAIM_CONTENT_TOP_${this.searchFormType}_COMPLETE_YMDT`)
    }
  ];

  public clickPeriod(periodType: string){
    (this.$refs.dateCalendar as any).clickPeriod(periodType)
  }
}
